<template>
  <div>
  <div style="font-size: 36px; font-weight: 700; margin-top: 80px; margin-bottom: 80px; text-align: center">Not yet
      open！</div>
    <!-- <h1>International Alumni Association</h1>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <lm-image1 :src="require('@/assets/temp/item711.png')"></lm-image1>
      </lm-container>
    </lm-swatches-block>
    <lm-swatches-block>
      <lm-container>
        <div class="item" v-for="(item, i) in contents" :key="i">
          <div class="img">
            <template v-if="type(item.img) === 'string'"><img :src="item.img" /></template>
            <template v-else>
              <img :src="target" v-for="(target, j) in item.img" :key="j" />
            </template>
          </div>
          <div class="title" @click="handleToArticle">{{ item.name }}</div>
        </div>
      </lm-container>
    </lm-swatches-block> -->
    <!-- <video-module :data="data.menus[0]"></video-module> -->
    <!-- <poster-gray-grid :data="data.menus[1]"></poster-gray-grid> -->
    <!-- <poster-module :type="2"></poster-module> -->
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      list: [],
      pageNumber: 1,
      pageSize: 8,
      totalRow: 0,
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    type(t) {
      return typeof t;
    },
    getPageData() {
      frontThrMenu({
        languageId: 'enNew',
        siteId: 'www',
        smu_menu1: 'y0lm77kcgi'
      }).then(res => {
        const apiIds = ['y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi', 'y0lm77kcgi']
        apiIds.forEach((apiId, i) => {
          ((i) => {
            frontArticles4Memu({
              memu1Id: 'y0lm76lhgr',
              memu2Id: apiId,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize
            }).then(res => {
              const item = res.data.list.splice(1, 3);
              this.list.splice(i, 1, item)
            })
          })(i)
        })
      })
    }
  }
}
</script>